import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSquareArrowUpRight = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M0.75 2.375V11.125C0.75 12.1094 1.51562 12.875 2.5 12.875H11.25C12.207 12.875 13 12.1094 13 11.125V2.375C13 1.41797 12.207 0.625 11.25 0.625H2.5C1.51562 0.625 0.75 1.41797 0.75 2.375ZM1.625 2.375C1.625 1.91016 2.00781 1.5 2.5 1.5H11.25C11.7148 1.5 12.125 1.91016 12.125 2.375V11.125C12.125 11.6172 11.7148 12 11.25 12H2.5C2.00781 12 1.625 11.6172 1.625 11.125V2.375ZM4.35938 8.63672C4.19531 8.80078 4.19531 9.10156 4.35938 9.26562C4.44141 9.34766 4.55078 9.375 4.6875 9.375C4.79688 9.375 4.90625 9.34766 4.98828 9.26562L8.625 5.62891V8.0625C8.625 8.30859 8.81641 8.5 9.0625 8.5C9.28125 8.5 9.5 8.30859 9.5 8.0625V4.58984C9.5 4.34375 9.28125 4.15234 9.0625 4.15234L5.5625 4.125C5.31641 4.125 5.125 4.34375 5.125 4.5625C5.09766 4.80859 5.31641 5 5.53516 5L7.99609 5.02734L4.35938 8.63672Z",
		fill: "#448AFF"
	})]
});
const ForwardRef = forwardRef(SvgSquareArrowUpRight);
export { ForwardRef as ReactComponent };
